const itemTypeEnum = Object.freeze({
  MENU_ITEM: 1,
  USER_ORDER_ITEM: 2,
  FAVORITE_MENU_ITEM: 3,
});

export default itemTypeEnum;
